import { render, staticRenderFns } from "./SieveFilterForm.vue?vue&type=template&id=9980116a&scoped=true"
import script from "./SieveFilterForm.vue?vue&type=script&lang=js"
export * from "./SieveFilterForm.vue?vue&type=script&lang=js"
import style0 from "./SieveFilterForm.vue?vue&type=style&index=0&id=9980116a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9980116a",
  null
  
)

export default component.exports